import { FileTextOutlined } from "@ant-design/icons";
import { message } from "antd";
import POSIcon from "../SvgComponent/POS";
import useAuthStore from "../../../../stores/useAuthStore";
import usePOSConfigStore from "../../../../stores/usePOSConfigStore";
import ParkedBillIcon from "../SvgComponent/ParkedBill";
import CashManagementIcon from "../SvgComponent/CashManagementIcon";
import SalesHistoryIcon from "../SvgComponent/SalesHistoryIcon";
import db from "../../../../database";
import { getPricingRules } from "../../../../utils/pricingRulesCache";
import discount from "../../../../assets/images/discount.svg";
import ReturnIcon from "../../../../assets/images/return.svg";
import SyncIcon from "../../../../assets/images/syncIcon.svg";
import giftVoucher from "../../../../assets/images/giftVoucher.svg";
import information from "../../../../assets/images/information.svg";
import user_add from "../../../../assets/images/user_add.svg";
import styles from "../../../../constants/styles.json";
import dayjs from "dayjs";
import useSessionStore from "../../../../stores/useSessionStore";
import useCartStore from "../../../../stores/useCartStore";
import useTransactionStore from "../../../../stores/useTransactionStore";

const SMCartMenuButtons = ({
  themeJSON,
  tillAccessData,
  posConfig,
  cart,
  isOnline,
  isStoreCredit,
  selectedProductInCart,
  pricePrecision,
  manualDiscountForm,
  openDisplayParkedBillModal,
  setManualDiscountModalVisible,
  setManualDiscountInput,
  setSelectedManualDiscountTypeValue,
  setProductSearchInput,
  renderAdditionalChargesButton,
  setReturnFlag,
  setIsPurchaseReturn,
  setIsCashManagement,
  handleKeyvalue,
  setIsEstimatesFlag,
  setGiftCardType,
  setIsGiftCardFlag,
  setIsNewGiftCardFlag,
  setGiftCardMode,
  setAddToBagFlag,
  setOpenSalesRep,
  setIsparkedBill,
  setParkedBillSearchInput,
  clearReturnCartData,
  setDateRange,
  setExpandedRowKeys,
  setSearchhistoryInput,
  setOrderHistoryDetails,
  setFiltersFlag,
  setShowReturnPurchase,
  searchOrderHistory,
  errorMessage,
}) => {
  return (
    <div
      data-zone="menuButtons"
      data-zone-label="Menu"
      tabIndex={-1}
      style={{
        width: "18%",
        paddingTop: "2%",
        paddingBottom: "1.5%",
        display: "flex",
        flexDirection: "column-reverse",
      }}
    >
      {/* Product Sync */}
      <div
        style={{
          width: "100%",
          marginBottom: "0.01rem",
          display: tillAccessData?.productSync === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-product-sync"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            let parkedBills = useSessionStore.getState().parkedList;
            if (cart.items.length > 0) {
              openDisplayParkedBillModal();
            } else if (parkedBills?.length > 0) {
              handleKeyvalue("parked-bill");
              setIsparkedBill(true);
            } else {
              if (isOnline) {
                handleKeyvalue("4");
              } else {
                errorMessage("Sync Failed", "Please check your network connection and try again");
              }
            }
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
              fontSize: "1vw",
            }}
          >
            <img src={SyncIcon} style={{ height: "2.5vh" }} color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Product Sync</span>
          </div>
        </button>
      </div>

      {/* POS (hidden) */}
      <div style={{ width: "100%", display: "none" }}>
        <button
          className="cartMenuItems"
          id="sm-pos"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <POSIcon color={"#fff"} />
            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
              Point of Sale
            </span>
          </div>
        </button>
      </div>

      {/* Information (hidden) */}
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: "none",
          fontSize: "1vw",
        }}
      >
        <button
          className="cartMenuItems"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <img src={information} style={{ height: "2.7vh" }} color={"#fff"} />
            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
              Information
            </span>
          </div>
        </button>
      </div>

      {/* Manual Discount */}
      <div style={{ width: "100%", marginBottom: "0.37rem", display: tillAccessData?.manualDiscount === "Y" ? "block" : "none" }}>
        <button
          className="cartMenuItems"
          id="sm-discount"
          style={{ backgroundColor: "#2F3856", border: "1px solid #2F3856", borderRadius: "7px", height: "9.5vh" }}
          onClick={async () => {
            const isExchangeLocal = useTransactionStore.getState().selectedReturnType === "EXCHANGE";
            const exchangeCartData = useCartStore.getState().exchangeCart;
            const activeCart = isExchangeLocal && exchangeCartData?.items?.length > 0 ? exchangeCartData : cart;
            if (selectedProductInCart) {
              const pr = getPricingRules();
              const index = pr.findIndex((md) => md.mPricingrulesId === selectedProductInCart?.mPricingruleId && md.manualDiscount === "Y");
              if (index !== -1) {
                const pricingRule = pr[index];
                if (pricingRule.type !== "TD") {
                  let discountValue =
                    pricingRule.discountType === "V"
                      ? selectedProductInCart.discount
                      : ((selectedProductInCart.discount / (selectedProductInCart?.realPrice * selectedProductInCart?.weight)) * 100).toFixed(pricePrecision);
                  manualDiscountForm.setFieldsValue({ discountName: pricingRule.mPricingrulesId, discountValue: discountValue });
                  setManualDiscountInput(discountValue);
                  setSelectedManualDiscountTypeValue(pricingRule);
                } else {
                  const matchedPricingRule = activeCart?.manualDiscountData?.totalLevelDiscount?.findIndex((item) => item.pricingRule === pricingRule.mPricingrulesId);
                  manualDiscountForm.setFieldsValue({
                    discountName: pricingRule.mPricingrulesId,
                    discountValue: activeCart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue,
                  });
                  setManualDiscountInput(activeCart?.manualDiscountData?.totalLevelDiscount[matchedPricingRule]?.discountValue);
                  setSelectedManualDiscountTypeValue(pricingRule);
                }
              } else {
                const totalDiscount = activeCart?.manualDiscountData?.totalLevelDiscount?.[0];
                if (totalDiscount?.pricingRule) {
                  const tdRule = pr.find((md) => md.mPricingrulesId === totalDiscount.pricingRule && md.manualDiscount === "Y");
                  if (tdRule) {
                    manualDiscountForm.setFieldsValue({ discountName: tdRule.mPricingrulesId, discountValue: totalDiscount.discountValue });
                    setManualDiscountInput(totalDiscount.discountValue);
                    setSelectedManualDiscountTypeValue(tdRule);
                  } else {
                    manualDiscountForm.resetFields();
                    setManualDiscountInput("");
                    setSelectedManualDiscountTypeValue("");
                  }
                } else {
                  manualDiscountForm.resetFields();
                  setManualDiscountInput("");
                  setSelectedManualDiscountTypeValue("");
                }
              }
            }
            activeCart.items.length > 0 && setManualDiscountModalVisible(true);
            setProductSearchInput("");
          }}
        >
          <div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column" }}>
            <img src={discount} style={{ height: "2.6vh" }} color={"#fff"} />
            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
              Manual Discount
            </span>
          </div>
        </button>
      </div>

      {/* Additional Charges Button (rendered by hook) */}
      {renderAdditionalChargesButton()}

      {/* Return (hidden) */}
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: "none",
          fontSize: "1vw",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-return"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            if (cart.items.length > 0) {
              openDisplayParkedBillModal();
            } else {
              handleKeyvalue("3");
              setReturnFlag(true);
              setIsPurchaseReturn(true);
            }
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <img src={ReturnIcon} style={{ height: "2.5vh" }} color={"#fff"} />
            <span className="posIcon" style={{ color: "#fff", fontSize: "0.8vw" }}>
              Return
            </span>
          </div>
        </button>
      </div>

      {/* Cash Management */}
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: tillAccessData?.cashManagement === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-cash-management"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            if (isOnline) {
              if (cart.items.length > 0) {
                openDisplayParkedBillModal();
              } else {
                handleKeyvalue("2");
                setIsCashManagement(true);
              }
            } else {
              errorMessage("Sync Failed", "Please check your network connection and try again");
            }
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <CashManagementIcon color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Cash Management</span>
          </div>
        </button>
      </div>

      {/* Gift Card */}
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: tillAccessData?.giftCard === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-sales-history"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            if (!isOnline) {
              errorMessage("Sync Failed", "Please check your network connection and try again");
              return;
            }
            if (posConfig?.showGiftCardSaleInInvoice === "Y") {
              setGiftCardType("Gift Card");
              setIsGiftCardFlag(true);
              setProductSearchInput("");
            } else {
              const saleTypeData = usePOSConfigStore.getState().saleTypeData || {};
              const matchedSaleType = useAuthStore.getState().tillData?.tillAccess?.csBunit?.b2cCustomer?.cwrCustomerId;
              const selectedCustomer = cart?.customer?.cwrCustomerId !== matchedSaleType && cart?.customer?.mobileNo !== null;
              if (!selectedCustomer) {
                message.warning("Please update customer mobile number to proceed with Gift Card");
                return;
              }
              if (typeof setGiftCardMode === "function") setGiftCardMode("topup");
              setIsNewGiftCardFlag(true);
              setProductSearchInput("");
            }
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <SalesHistoryIcon color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Gift Card</span>
          </div>
        </button>
      </div>

      {/* Bag */}
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: posConfig?.showBags === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-discount"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            setAddToBagFlag(true);
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <img src={giftVoucher} style={{ height: "2.6vh" }} color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Bag</span>
          </div>
        </button>
      </div>

      {/* Sales Representative */}
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: posConfig?.showOrderSalesRep === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-parked-bill"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            setOpenSalesRep({ flag: true, level: "order" });
            setProductSearchInput("");
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <img src={user_add} style={{ color: "#fff", height: "2.5vh" }} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Sales Representative</span>
          </div>
        </button>
      </div>

      {/* Parked Bills */}
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: tillAccessData?.parkedBills === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-parked-bill"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
            cursor: isStoreCredit ? "not-allowed" : "pointer",
          }}
          disabled={isStoreCredit}
          onClick={() => {
            if (isStoreCredit) return;
            handleKeyvalue("parked-bill");
            setIsparkedBill(true);
            setParkedBillSearchInput("");
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <ParkedBillIcon color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Parked Bills</span>
          </div>
        </button>
      </div>

      {/* Sales History */}
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: tillAccessData?.salesHistory === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-sales-history"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            if (cart.items.length > 0) {
              clearReturnCartData();
            } else {
              if (isOnline) {
                handleKeyvalue("3");
                // Use empty array (not "") so the controlled RangePicker value stays valid.
                // Setting to "" invalidated antd's controlled state and broke subsequent date selections.
                setDateRange([]);
                setIsPurchaseReturn(true);
                setReturnFlag(false);
                setShowReturnPurchase(false);
                setExpandedRowKeys([]);
                setSearchhistoryInput("");
                setOrderHistoryDetails([]);
                setFiltersFlag(false);
                let dateValue = [dayjs().startOf("day"), dayjs()];
                setDateRange(dateValue);
                searchOrderHistory("orderDateSearchKey", dateValue, 0, false, true);
              } else {
                errorMessage("Sync Failed", "Please check your network connection and try again");
              }
            }
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <SalesHistoryIcon color={"#fff"} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Sales History</span>
          </div>
        </button>
      </div>

      {/* Estimates */}
      <div
        style={{
          width: "100%",
          marginBottom: "0.37rem",
          display: posConfig?.showEstimates === "Y" ? "block" : "none",
        }}
      >
        <button
          className="cartMenuItems"
          id="sm-sales-history"
          style={{
            backgroundColor: themeJSON.cartMenuItemsBGColor || "#2F3856",
            border: `1px solid ${themeJSON.cartMenuItemsBGColor || "#2F3856"}`,
            borderRadius: "7px",
            height: "9.5vh",
          }}
          onClick={() => {
            setIsEstimatesFlag(true);
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexDirection: "column",
            }}
          >
            <FileTextOutlined style={{ fontSize: "16px" }} />
            <span style={styles.screenStyles.mainScreen.posIcon}>Estimates</span>
          </div>
        </button>
      </div>
    </div>
  );
};

export default SMCartMenuButtons;
